import React from "react";

const Bangabandhu = () => {
  return (
    <div className="sm: text-center lg:text-left lg:px-16">
      <div className="max-w-full overflow-hidden text-center">
        <img
          src="./bangabandhu.webp"
          alt="bangabandhu"
          className="m-auto mt-10 md:w-3/12 lg: w-6/12"
        />
        <h1 className="text-xl mt-4 text-[#F97317] font-bold">
          জাতির জনক বঙ্গবন্ধু শেখ মুজিবুর রহমান
        </h1>
        <p className="my-8">বঙ্গবন্ধু শেখ মুজিবুর রহমানের সংক্ষিপ্ত জীবনী</p>
      </div>
      <div className=" px-8 py-8">
        <div className="block">
          <p className="text-[#F97317] font-bold my-4 text-lg">১৯২০</p>
          <p>
            জাতির জনক বঙ্গবন্ধু শেখ মুজিবুর রহমান ফরিদপুর জেলার গোপালগঞ্জ
            মহকুমার (বর্তমানে জেলা) টুঙ্গিপাড়া গ্রামে এক সম্ভ্রান্ত মুসলিম
            পরিবারে ১৯২০ সালের ১৭ মার্চ জন্মগ্রহণ করেন। শেখ লুৎফর রহমান ও
            মোসাম্মৎ সাহারা খাতুনের চার কন্যা ও দুই পুত্রের মধ্যে তৃতীয় সন্তান
            শেখ মুজিব। বাবা-মা ডাকতেন খোকা বলে। খোকার শৈশবকাল কাটে
            টুঙ্গি-পাড়ায়।
          </p>
        </div>
        <div className="block">
          <p className="text-[#F97317] font-bold my-4 text-lg">১৯৪২</p>
          <p>
            এস.এস.সি পাস করেন। কলকাতা ইসলামিয়া কলেজে মানবিক বিভাগে
            ইন্টারমিডিয়েট ক্লাসে ভর্তি হন এবং বেকার হোস্টেলে থাকার ব্যবস্থা
            হয়। বঙ্গবন্ধু এই বছরেই পাকিস্তান আন্দোলনের সাথে সক্রিয়ভাবে যুক্ত
            হয়ে পড়েন।
          </p>
        </div>
        <div className="block">
          <p className="text-[#F97317] font-bold my-4 text-lg">১৯২৭</p>
          <p>
            ৭ বছর বয়সে গিমাডাঙ্গা প্রাইমারি স্কুলে পড়াশোনা শুরু করেন। নয় বছর
            বয়সে গোপালগঞ্জ পাবলিক স্কুলে তৃতীয় শ্রেণীতে ভর্তি হন। পরে তিনি
            স্থানীয় মিশনারি স্কুলে ভর্তি হন।
          </p>
        </div>
        <div className="block">
          <p className="text-[#F97317] font-bold my-4 text-lg">১৯৪৮</p>
          <p>
            ঢাকা বিশ্ববিদ্যালয়ে আইন বিভাগে ভর্তি হন এবং ৪ জানুয়ারি মুসলিম
            ছাত্রলীগ প্রতিষ্ঠা করেন। ২৩ ফেব্রুয়ারি প্রধানমন্ত্রী খাজা নাজিম
            উদ্দিন আইন পরিষদে ‘পূর্ব পাকিস্তানের জনগণ উর্দুকে রাষ্ট্রভাষা হিসেবে
            মেনে নেবে’ বলে ঘোষণা দিলে তাৎক্ষণিক-ভাবে বঙ্গবন্ধু এর প্রতিবাদ
            জানান। খাজা নাজিমুদ্দিনের বক্তব্যে সারাদেশে প্রতিবাদের ঝড় ওঠে। শেখ
            মুজিব মুসলিম লীগের এই পরিকল্পনার বিরুদ্ধে আন্দোলনের প্রস্তুতি
            গ্রহণের জন্য কর্মতৎপরতা শুরু করেন। বঙ্গবন্ধু ছাত্র ও রাজনৈতিক
            নেতৃবৃন্দের সাথে যোগাযোগ করেন। ২ মার্চ ভাষা প্রসঙ্গে মুসলিম লীগের
            বিরুদ্ধে আন্দোলনকে সংগঠিত করার লক্ষ্যে বিভিন্ন রাজনৈতিক দলের
            কর্মীদের এক বৈঠক অনুষ্ঠিত হয়। ফজলুল হক মুসলিম হলে অনুষ্ঠিত এই বৈঠকে
            বঙ্গবন্ধুর প্রস্তাবμমে ‘সর্বদলীয় রাষ্ট্রভাষা সংগ্রাম পরিষদ’ গঠিত
            হয়। সংগ্রাম পরিষদ বাংলা ভাষা নিয়ে মুসলিম লীগের ষড়যন্ত্রের
            বিরুদ্ধে প্রতিবাদ জানাতে ১১ মার্চ সাধারণ ধর্মঘট আহ্বান করে। ১১ মার্চ
            বাংলা ভাষার দাবিতে ধর্মঘট পালনকালে বঙ্গবন্ধু সহকর্মীদের সাথে
            সচিবালয়ের সামনে বিক্ষোভরত অবস্থায় গ্রেফতার হন। বঙ্গবন্ধুকে
            গ্রেফতারে সারাদেশে ছাত্রসমাজ প্রতিবাদে ফেটে পড়ে। মুসলিম লীগ সরকার
            ছাত্রদের আন্দোলনের চাপে বঙ্গবন্ধুসহ গ্রেফতারকৃত ছাত্র নেতৃবৃন্দকে
            মুক্তি দিতে বাধ্য হয়। বঙ্গবন্ধু ১৫ মার্চ মুক্তি লাভ করেন। বঙ্গবন্ধু
            মুক্তি লাভের পর ১৬ মার্চ ঢাকা বিশ্ববিদ্যালয়ের আমতলায় সর্বদলীয়
            রাষ্ট্রভাষা সংগ্রাম পরিষদের উদ্যোগে ছাত্র-জনতার সভার আয়োজন করা হয়।
            এই সভায় বঙ্গবন্ধু সভাপতিত্ব করেন। সভায় পুলিশ হামলা চালায়। পুলিশি
            হামলার প্রতিবাদে সভা থেকে বঙ্গবন্ধু ১৭ মার্চ শিক্ষা প্রতিষ্ঠানে
            ধর্মঘট পালনের আহ্বান জানান। ১১ সেপ্টেম্বর ফরিদপুরে কর্ডন প্রথার
            বিরুদ্ধে আন্দোলন করার জন্য তাকে গ্রেফতার করা হয়।
          </p>
        </div>
        <div className="block">
          <p className="text-[#F97317] font-bold my-4 text-lg">১৯৪৯</p>
          <p>
            ২১ জানুয়ারি শেখ মুজিব কারাগার থেকে মুক্তি পান। ঢাকা
            বিশ্ববিদ্যালয়ের চতুর্থ শ্রেণীর কর্মচারীরা তাদের দাবি-দাওয়া আদায়ের
            উদ্দেশ্যে ধর্মঘট ঘোষণা করলে বঙ্গবন্ধু ধর্মঘটের প্রতি সমর্থন জানান।
            কর্মচারীদের এ আন্দোলনে নেতৃত্ব দেয়ার অভিযোগে ২৯ মার্চ
            বিশ্ববিদ্যালয় কর্তৃপক্ষ অযৌক্তিকভাবে তাকে জরিমানা করে। তিনি এ
            অন্যায় নির্দেশ ঘৃণাভরে প্রত্যাখ্যান করেন। ফলে বিশ্ববিদ্যালয় থেকে
            বহি®কৃত হন। ১৯ এপ্রিল উপাচার্যের বাসভবনের সামনে অবস্থান ধর্মঘট করার
            কারণে গ্রেপ্তার হন। ২৩ জুন পূর্ব পাকিস্তান আওয়ামী মুসলিম লীগ গঠিত
            হয় এবং জেলে থাকা অবস্থায় বঙ্গবন্ধু এ দলের যুগ্ম সম্পাদক নির্বাচিত
            হন। জুলাই মাসের শেষের দিকে মুক্তিলাভ করেন। জেল থেকে বেরিয়েই দেশে
            বিরাজমান প্রকট খাদ্য সংকটের বিরুদ্ধে আন্দোলন সংগঠিত করতে থাকেন।
            সেপ্টেম্বরে ১৪৪ ধারা ভঙ্গের দায়ে গ্রেপ্তার হন ও পরে মুক্তি লাভ
            করেন। ১১ অক্টোবরে অনুষ্ঠিত আওয়ামী মুসলিম লীগের সভায় নূরুল আমিনের
            পদত্যাগ দাবি করেন। পাকিস্তানের প্রধানমন্ত্রী লিয়াকত আলী খানের আগমন
            উপলক্ষে আওয়ামী মুসলিম লীগ ভুখা মিছিল বের করে। এই মিছিলে নেতৃত্ব
            দেবার জন্য ১৪ অক্টোবর শেখ মুজিবুর রহমানকে গ্রেপ্তার করা হয়। এবারে
            তাকে প্রায় দু বছর পাঁচ মাস জেলে আটক রাখা হয়।
          </p>
        </div>
        <div className="block">
          <p className="text-[#F97317] font-bold my-4 text-lg">১৯৫২</p>
          <p>
            ২৬ জানুয়ারি খাজা নাজিমুদ্দিন ঘোষণা করেন ‘পাকিস্তানের রাষ্ট্রভাষা
            হবে উর্দু’। এর প্রতিবাদে বন্দি থাকা অবস্থায় ২১ ফেব্রুয়ারিকে
            রাজবন্দি মুক্তি এবং বাংলাকে রাষ্ট্রভাষা করার দাবি দিবস হিসেবে পালন
            করার জন্য বঙ্গবন্ধু রাষ্ট্রভাষা সংগ্রাম পরিষদের প্রতি আহ্বান জানান।
            ১৪ ফেব্রুয়ারি বঙ্গবন্ধু এ দাবিতে জেলখানায় অনশন শুরু করেন। ২১
            ফেব্রুয়ারি রাষ্ট্রভাষা বাংলার দাবিতে ছাত্র সমাজ ১৪৪ ধারা ভঙ্গ করে
            মিছিল বের করে। মিছিলে পুলিশ গুলি চালালে সালাম, বরকত, রফিক, শফিউর
            শহীদ হন। বঙ্গবন্ধু জেলখানা থেকে এক বিবৃতিতে ছাত্র মিছিলে পুলিশের
            গুলিবর্ষণের তীব্র নিন্দা ও প্রতিবাদ জানান। একটানা ১৭ দিন অনশন
            অব্যাহত রাখেন। জেলখানা থেকে আন্দোলনকারীদের সঙ্গে যোগাযোগ রাখার দায়ে
            তাকে ঢাকা জেলখানা থেকে ফরিদপুর জেলে সরিয়ে নেওয়া হয়। ২৬
            ফেব্রুয়ারি ফরিদপুর জেল থেকে তিনি মুক্তিলাভ করেন। ডিসেম্বর মাসে তিনি
            “পিকিং”-এ বিশ্বশান্তি সম্মেলনে যোগদান করেন।
          </p>
        </div>
        <div className="block">
          <p className="text-[#F97317] font-bold my-4 text-lg">১৯৬৯</p>
          <p>
            ৫ জানুয়ারি ৬ দফাসহ ১১ দফা দাবি আদায়ের লক্ষ্যে কেন্দ্রীয় ছাত্র
            সংগ্রাম পরিষদ গঠিত হয়। কেন্দ্রীয় ছাত্র সংগ্রাম পরিষদ আগরতলা
            ষড়যন্ত্র মামলা প্রত্যাহার ও বঙ্গবন্ধুর মুক্তির দাবিতে দেশব্যাপী
            ছাত্র আন্দোলন শুরু করে। এই আন্দোলন গণআন্দোলনে পরিণত হয়। পরে ১৪৪
            ধারা ও কার্ফু ভঙ্গ, পুলিশ-ইপিআর-এর গুলিবর্ষণ, বহু হতাহতের মধ্য দিয়ে
            গণ-অভ্যুত্থানে রূপ নিলে আইয়ুব সরকার ১ ফেব্রুয়ারি গোলটেবিল বৈঠকের
            আহ্বান জানায় এবং বঙ্গবন্ধুকে প্যারোলে মুক্তিদান করা হবে বলে ঘোষণা
            দেয়া হয়। বঙ্গবন্ধু প্যারোলে মুক্তিদান প্রত্যাখ্যান করেন। ২২
            ফেব্রুয়ারি জনগণের অব্যাহত চাপের মুখে কেন্দ্রীয় সরকার আগরতলা
            ষড়যন্ত্র মামলা প্রত্যাহার করে বঙ্গবন্ধুসহ অন্যান্য আসামিকে মুক্তি
            দানে বাধ্য হয়। ২৩ ফেব্রুয়ারি রেসকোর্স (সোহরাওয়ার্দী উদ্যান)
            ময়দানে কেন্দ্রীয় ছাত্র সংগ্রাম পরিষদের উদ্যোগে বঙ্গবন্ধুকে
            সংবর্ধনার আয়োজন করা হয়। প্রায় ১০ লাখ ছাত্র জনতার এই সংবর্ধনা
            সমাবেশে শেখ মুজিবুর রহমানকে আনুষ্ঠানিকভাবে ‘বঙ্গবন্ধু’ উপাধিতে ভূষিত
            করা হয়। বঙ্গবন্ধু রেসকোর্স ময়দানের ভাষণে ছাত্র সমাজের ১১ দফা দাবির
            প্রতি পূর্ণ সমর্থন জানান। ১০ মার্চ বঙ্গবন্ধু রাওয়ালপিন্ডিতে আইয়ুব
            খানের গোলটেবিল বৈঠকে যোগদান করেন। বঙ্গবন্ধু গোলটেবিল বৈঠকে আওয়ামী
            লীগের ৬ দফা ও ছাত্র সমাজের ১১ দফা দাবি উপস্থাপন করে বলেন,
            ‘গণ-অসন্তোষ নিরসনে ৬ দফা ও ১১ দফার ভিত্তিতে আঞ্চলিক স্বায়ত্তশাসন
            প্রদান ছাড়া আর কোন বিকল্প নেই।’ পাকিস্তানে শাসকগোষ্ঠী ও
            রাজনীতিবিদরা বঙ্গবন্ধুর দাবি অগ্রাহ্য করলে ১৩ মার্চ তিনি গোলটেবিল
            বৈঠক ত্যাগ করেন এবং ১৪ মার্চ ঢাকায় ফিরে আসেন। ২৫ মার্চ জেনারেল
            ইয়াহিয়া খান সামরিক শাসন জারির মাধ্যমে ক্ষমতাসীন হন। ২৫ অক্টোবর
            বঙ্গবন্ধু তিন সপ্তাহের সাংগঠনিক সফরে লন্ডন গমন করেন। ৫ ডিসেম্বর শহীদ
            সোহরাওয়ার্দীর মৃত্যুবার্ষিকী উপলক্ষে আওয়ামী লীগের আলোচনা সভায়
            বঙ্গবন্ধু পূর্ব বাংলার নামকরণ করেন ‘বাংলাদেশ’। তিনি বলেন, “একসময়
            এদেশের বুক হইতে, মানচিত্রের পৃষ্ঠা হইতে ‘বাংলা’ কথাটির সর্বশেষ
            চিহ্নটুকুও চিরতরে মুছিয়া ফেলার চেষ্টা করা হইয়াছে। … একমাত্র
            ‘বঙ্গোপসাগর’ ছাড়া আর কোন কিছুর নামের সঙ্গে ‘বাংলা’ কথাটির অস্তিত্ব
            খুঁজিয়া পাওয়া যায় নাই। … জনগণের পক্ষ হইতে আমি ঘোষণা করিতেছি- আজ
            হইতে পাকিস্তানের পূর্বাঞ্চলীয় প্রদেশটির নাম ‘পূর্ব পাকিস্তানে’র
            পরিবর্তে শুধুমাত্র ‘বাংলাদেশ’।
          </p>
        </div>
        <div className="block">
          <p className="text-[#F97317] font-bold my-4 text-lg">১৯৭১</p>
          <p>
            ৩ জানুয়ারি রেসকোর্সের জনসভায় বঙ্গবন্ধু শেখ মুজিব জনপ্রতিনিধিদের
            শপথ গ্রহণ পরিচালনা করেন। আওয়ামী লীগ দলীয় সদস্যরা ৬ দফার ভিত্তিতে
            শাসনতন্ত্র রচনা এবং জনগণের প্রতি আনুগত্য থাকার শপথ গ্রহণ করেন। ৫
            জানুয়ারি তৎকালীন পশ্চিম পাকিস্তানে সর্বাধিক আসন লাভকারী পাকিস্তান
            পিপলস পার্টির নেতা জুলফিকার আলী ভুট্টো কেন্দ্রে আওয়ামী লীগের সাথে
            কোয়ালিশন সরকার গঠনে তার সম্মতির কথা ঘোষণা করেন। জাতীয় পরিষদ এক
            বৈঠকে বঙ্গবন্ধু পার্লামেন্টারি দলের নেতা নির্বাচিত হন। ২৮ জানুয়ারি
            জুলফিকার আলী ভুট্টো বঙ্গবন্ধুর সাথে আলোচনার জন্য ঢাকায় আসেন। তিনদিন
            বৈঠকের পর আলোচনা ব্যর্থ হয়ে যায়। ১৩ ফেব্রুয়ারি প্রেসিডেন্ট
            ইয়াহিয়া খান ৩ মার্চ ঢাকায় জাতীয় পরিষদের বৈঠক আহ্বান করেন। ১৫
            ফেব্রুয়ারি ভুট্টো ঢাকায় জাতীয় পরিষদের বৈঠক বয়কটের ঘোষণা দিয়ে
            দুই প্রদেশে সংখ্যাগরিষ্ঠ দুই দলের প্রতি ক্ষমতা হস্তান্তর করার দাবি
            জানান। ১৬ ফেব্রুয়ারি বঙ্গবন্ধু এক বিবৃতিতে জনাব ভুট্টোর দাবির তীব্র
            সমালোচনা করে বলেন, ‘ভুট্টো সাহেবের দাবি সম্পূর্ণ অযৌক্তিক। ক্ষমতা
            একমাত্র সংখ্যাগরিষ্ঠ দল আওয়ামী লীগের কাছে হস্তান্তর করতে হবে।
            ক্ষমতার মালিক এখন পূর্ব বাংলার জনগণ।’ ১ মার্চ ইয়াহিয়া খান
            অনির্দিষ্টকালের জন্য জাতীয় পরিষদের বৈঠক স্থগিতের ঘোষণা দিলে সারা
            বাংলায় প্রতিবাদের ঝড় ওঠে। বঙ্গবন্ধুর সভাপতিত্বে আওয়ামী লীগ
            কার্যকরী পরিষদের জরুরি বৈঠকে ২ মার্চ দেশব্যাপী হরতাল আহ্বান করা হয়।
            ৩ মার্চ সারা বাংলায় হরতাল পালিত হবার পর বঙ্গবন্ধু অবিলম্বে ক্ষমতা
            হস্তান্তর করার জন্য প্রেসিডেন্টের প্রতি দাবি জানান। ৭ মার্চ
            রেসকোর্সের জনসমুদ্র থেকে বঙ্গবন্ধু শেখ মুজিবুর রহমান ঘোষণা করেন
            ‘এবারের সংগ্রাম আমাদের মুক্তির সংগ্রাম, এবারের সংগ্রাম স্বাধীনতার
            সংগ্রাম, জয় বাংলা’। ঐতিহাসিক ভাষণে জাতির জনক বঙ্গবন্ধু বাঙালি
            জাতিকে শৃঙ্খল মুক্তির আহ্বান জানিয়ে ঘোষণা করেন, “রক্ত যখন দিয়েছি
            রক্ত আরও দেবো। এদেশের মানুষকে মুক্ত করে ছাড়বো ইনশাআল্লাহ্। …
            প্রত্যেকে ঘরে ঘরে দুর্গ গড়ে তোল। যার যা কিছু আছে তাই নিয়ে মোকাবেলা
            করতে হবে।” শত্রু“র বিরুদ্ধে গেরিলা যুদ্ধের প্রস্তুতি নেবার আহ্বান
            জানান। বঙ্গবন্ধু ইয়াহিয়া খানের সরকারের বিরুদ্ধে অসহযোগ আন্দোলনের
            ডাক দেন। একদিকে রাষ্ট্রপতি জেনারেল ইয়াহিয়ার নির্দেশ যেত অপরদিকে
            ধানমন্ডি ৩২ নং সড়ক থেকে বঙ্গবন্ধুর নির্দেশ যেত, বাংলার মানুষ
            বঙ্গবন্ধুর নির্দেশ মেনে চলতেন। অফিস-আদালত, ব্যাংক-বীমা, স্কুল-কলেজ,
            গাড়ি, শিল্প-কারখানা সবই বঙ্গবন্ধুর নির্দেশ মেনেছে। ইয়াহিয়ার সব
            নির্দেশ অমান্য করে অসহযোগ আন্দোলনে বাংলার মানুষের সেই অভূতপূর্ব
            সাড়া ইতিহাসে বিরল ঘটনা। মূলত ৭ মার্চ থেকে ২৫ মার্চ বাংলাদেশ স্বাধীন
            দেশ হিসেবে বঙ্গবন্ধুই রাষ্ট্রপরিচালনা করেছেন। ১৬ মার্চ ঢাকায় ক্ষমতা
            হস্তান্তর প্রসঙ্গ মুজিব-ইয়াহিয়া বৈঠক শুরু হয়। আলোচনার জন্য জনাব
            ভুট্টো ও ঢাকায় আসেন। ২৪ মার্চ পর্যন্ত ইয়াহিয়া-মুজিব-ভুট্টো আলোচনা
            হয়। ২৫ মার্চ আলোচনা ব্যর্থ হবার পর সন্ধ্যায় ইয়াহিয়ার ঢাকা ত্যাগ।
            ২৫ মার্চ দিবাগত রাতে নিরীহ নিরস্ত্র বাঙালির ওপর পাকিস্তান সেনাবাহিনী
            ঝাঁপিয়ে পড়ে। আক্রমণ করে ঢাকা বিশ্ববিদ্যালয়, পিলখানা রাইফেল সদর
            দফতর ও রাজারবাগ পুলিশ হেড কোয়ার্টার। বঙ্গবন্ধু ২৫শে মার্চ রাত ১২টা
            ২০ মিনিটে বাংলাদেশের স্বাধীনতা ঘোষণা করেন :
          </p>
          <blockquote className="border border-l-slate-800 border-spacing-4 my-4">
            <p className="italic pl-2 text-amber-900">
              This may be my last message, from today Bangladesh is independent.
              I call upon the people of Bangladesh wherever you might be and
              with whatever you have, to resist the army of occupation to the
              last. Your fight must go on until the last soldier of the pakistan
              occupation army is expelled from the soil of Bangladesh. Final
              victory is ours.{" "}
              <span className="text-black block my-2">
                {" "}
                - শেখ মুজিবুর রহমান
              </span>
            </p>
          </blockquote>
        </div>
        <div className="block">
          <p>
            অনুবাদ : [‘সম্ভবতঃ এটাই আমার শেষ বার্তা, আজ থেকে বাংলাদেশ স্বাধীন।
            আমি বাংলাদেশের জনসাধারণকে আহ্বান জানাচ্ছি তোমরা যে যেখানেই আছ এবং
            যাই তোমাদের হাতে আছে তার দ্বারাই শেষ মুহূর্ত পর্যন্ত দখলদার
            সৈন্যবাহিনীকে প্রতিরোধ করতে হবে। যতক্ষণ না পাকিস্তান দখলদার বাহিনীর
            শেষ ব্যক্তি বাংলাদেশের মাটি থেকে বিতাড়িত হবে এবং যতক্ষণ পর্যন্ত না
            চূড়ান্ত বিজয় অর্জিত হবে, তোমাদের যুদ্ধ চালিয়ে যেতে হবে।’] এই
            ঘোষণা বাংলাদেশের সর্বত্র ট্রান্সমিটারে প্রেরিত হয়।
          </p>
          <blockquote className="border border-l-slate-800 border-spacing-4 my-4">
            <p className="italic pl-2 text-amber-900">
              পাকিস্তান সেনাবাহিনী অতর্কিতভাবে পিলখানা ইপিআর ঘাঁটি, রাজারবাগ
              পুলিশ লাইন আμমণ করেছে এবং শহরের রাস্তায় রাস্তায় যুদ্ধ চলছে, আমি
              বিশ্বের জাতিসমূহের কাছে সাহায্যের আবেদন করছি। আমাদের
              মুক্তিযোদ্ধারা বীরত্বের সঙ্গে মাতৃভূমি মুক্ত করার জন্য শত্রু দের
              সঙ্গে যুদ্ধ করছে। সর্বশক্তিমান আল্লাহর নামে আপনাদের কাছে আমার
              আবেদন ও আদেশ দেশকে স্বাধীন করার জন্য শেষ রক্তবিন্দু থাকা পর্যন্ত
              যুদ্ধ চালিয়ে যান। আপনাদের পাশে এসে যুদ্ধ করার জন্য পুলিশ, ইপিআর,
              বেঙ্গল রেজিমেন্ট ও আনসারদের সাহায্য চান। কোন আপোষ নাই। জয় আমাদের
              হবেই। পবিত্র মাতৃভূমি থেকে শেষ শত্রু কে বিতাড়িত করুন। সকল আওয়ামী
              লীগ নেতা-কর্মী এবং অন্যান্য দেশপ্রেমিক প্রিয় লোকদের কাছে এ সংবাদ
              পৌঁছে দিন। আল্লাহ আপনাদের মঙ্গল করুন। জয় বাংলা।
              <span className="text-black block my-2">
                {" "}
                - শেখ মুজিবুর রহমান
              </span>
            </p>
          </blockquote>
          <p>
            হানাদার পাকিস্তান বাহিনীর বিরুদ্ধে প্রতিরোধ যুদ্ধে অংশগ্রহণের জন্য
            বাঙালি সামরিক ও বেসামরিক যোদ্ধা, ছাত্র, শ্রমিক, কৃষকসহ সর্বস্তরের
            জনগণের প্রতি আহ্বান জানান। বঙ্গবন্ধুর এই আহ্বান বেতার যন্ত্র মারফত
            তাৎক্ষণিক-ভাবে বিশেষ ব্যবস্থায় সারাদেশে পাঠানো হয়। রাতেই এই বার্তা
            পেয়ে চট্টগ্রাম, কুমিল্লা ও যশোর সেনানিবাসে বাঙালি জওয়ান ও অফিসাররা
            প্রতিরোধ গড়ে তোলেন। চট্টগ্রাম বেতার কেন্দ্র থেকে বঙ্গবন্ধুর ঘোষণা
            প্রচার করা হয় গভীর রাতে। স্বাধীনতার ঘোষণা দেবার অপরাধে পাকিস্তান
            সেনাবাহিনী ১-১০ মিনিটে বঙ্গবন্ধুকে ধানমন্ডির ৩২ নং বাসভবন থেকে
            গ্রেফতার করে ঢাকা সেনানিবাসে নিয়ে যায় এবং ২৬ মার্চ তাকে বন্দি
            অবস্থায় পাকিস্তান নিয়ে যাওয়া হয়। ২৬শে মার্চ জেঃ ইয়াহিয়া এক
            ভাষণে আওয়ামী লীগকে নিষিদ্ধ ঘোষণা করে বঙ্গবন্ধুকে দেশদ্রোহী বলে
            আখ্যায়িত করে। ২৬ মার্চ চট্টগ্রাম স্বাধীন বাংলা বেতার কেন্দ্র থেকে
            চট্টগ্রামের আওয়ামী লীগ নেতা এম এ হান্নান বঙ্গবন্ধুর স্বাধীনতা
            ঘোষণাপত্রটি পাঠ করেন। ১০ এপ্রিল বঙ্গবন্ধু শেখ মুজিবুর রহমানকে
            রাষ্ট্রপতি করে বিপ্লবী সরকার গঠিত হয়। ১৭ এপ্রিল মেহেরপুরের
            বৈদ্যনাথতলার আম্রকাননে (মুজিবনগর) বাংলাদেশ সরকারের শপথ গ্রহণ
            অনুষ্ঠিত হয়। বঙ্গবন্ধু রাষ্ট্রপতি, সৈয়দ নজরুল ইসলাম অস্থায়ী
            রাষ্ট্রপতি এবং তাজউদ্দিন আহমদ প্রধানমন্ত্রী নির্বাচিত হন। প্রবাসী
            বাংলাদেশ সরকারের পরিচালনায় মুক্তিযুদ্ধ শেষে ১৬ ডিসেম্বর ঐতিহাসিক
            রেসকোর্স ময়দানে পাকিস্তান বাহিনীর আত্মসমর্পণের মধ্য দিয়ে
            মুক্তিযুদ্ধে বিজয় অর্জিত হয়। বাংলাদেশ লাভ করে স্বাধীনতা। তার আগে ৭
            সেপ্টেম্বর পাকিস্তানের লায়ালপুর সামরিক জেলে বঙ্গবন্ধুর গোপন বিচার
            করে তাকে দেশদ্রোহী ঘোষণা করে মৃত্যুদণ্ড প্রদান করা হয়। বিভিন্ন দেশ
            ও বিশ্বের মুক্তিকামী জনগণ বঙ্গবন্ধুর জীবনের নিরাপত্তার দাবি জানায়।
            ২৭ ডিসেম্বর বাংলাদেশ সরকারের পক্ষ থেকে জাতির জনক রাষ্ট্রপতি শেখ
            মুজিবুর রহমানকে অবিলম্বে নিঃশর্ত মুক্তি প্রদানের দাবি জানানো হয়।
            ভারত ও সোভিয়েত ইউনিয়নসহ বিভিন্ন দেশ ও আন্তর্জাতিক সংস্থার পক্ষ
            থেকে বঙ্গবন্ধুর মুক্তির জন্য পাকিস্তান সরকারের প্রতি আহ্বান জানিয়ে
            বলা হয়, শেখ মুজিবুর রহমান স্বাধীন বাংলাদেশের রাষ্ট্রপতি। তিনি
            বাংলাদেশের স্থপতি, কাজেই পাকিস্তানের কোন অধিকার নেই তাকে বন্দি করে
            রাখার। বাংলাদেশ ইতিমধ্যে বহু রাষ্ট্রের স্বীকৃতি লাভ করেছে।
          </p>
        </div>
        <div className="block">
          <p className="mt-8 font-light">
            সূত্র: বঙ্গবন্ধু শেখ মুজিবুর রহমান মেমোরিয়াল ট্রাস্ট, রাস্তা-৩২,
            ধানমন্ডি আবাসিক এলাকা, ঢাকা-১২০৯
          </p>
          <p></p>
        </div>
      </div>
    </div>
  );
};

export default Bangabandhu;
